// Bản mirror JS của saola-quiz3-api/omr/build_template.py — PHẢI khớp 1-1 để
// vị trí ô tròn in ra giấy đúng với vị trí OMRChecker mong đợi khi quét ảnh.
// Sửa bên nào thì phải sửa đồng thời bên kia.
//
// Ghi chú quan trọng: OMRChecker luôn resize ảnh (sau khi crop theo 4 marker
// góc) về đúng kích thước "pageDimensions" trước khi đọc bubble — nên toạ độ
// chỉ cần khớp THEO TỈ LỆ (phần trăm) với pageDimensions, không cần khớp
// kích thước vật lý (mm) thật của trang in. Vì vậy hàm này trả về toạ độ
// dạng PHẦN TRĂM (0-100) để đặt CSS left/top/width/height cho vùng chứa
// "phiếu trả lời" (vùng tính từ tâm marker góc trái-trên tới tâm marker góc
// phải-dưới), bất kể vùng đó vật lý rộng/cao bao nhiêu mm.

export const PAGE_W = 1000;
export const PAGE_H = 1414;

const MARGIN = 80;
const HEADER_H = 170;
const FOOTER_MARGIN = 40;

export const BUBBLE = 30;
const NUMBER_LABEL_W = 50;
const ROW_PAD = 10;
const BUBBLES_GAP = 65;
const MAX_ROW_HEIGHT = 90;
const COL_GAP = 40;
const MAX_QUESTIONS_SINGLE_COL = 15;

// Kích thước/khoảng cách marker góc trên trang in — xem
// Quiz3PrintSheet.js. Phải khớp với "sheetToMarkerWidthRatio" bên Python
// (~ khổ A4 210mm / MARKER_BOX_MM).
export const MARKER_BOX_MM = 14;
export const PAGE_EDGE_MARGIN_MM = 10; // lề từ mép giấy tới mép ngoài marker

const pct = (px, total) => (px / total) * 100;

// Trả về { numCols, rows: [{questionIndex(0-based), col, bubbles:[{value,leftPct,topPct}], numberLeftPct, numberTopPct}] }
export function computeAnswerSheetLayout(numQuestions) {
  const numCols = numQuestions <= MAX_QUESTIONS_SINGLE_COL ? 1 : 2;

  const gridTop = MARGIN + HEADER_H;
  const gridBottom = PAGE_H - MARGIN - FOOTER_MARGIN;
  const gridHeight = gridBottom - gridTop;
  const gridLeft = MARGIN;
  const gridRight = PAGE_W - MARGIN;
  const gridWidth = gridRight - gridLeft;

  const rowsPerCol = Math.ceil(numQuestions / numCols);
  const colWidth = numCols === 1 ? gridWidth : (gridWidth - COL_GAP) / 2;
  const rowHeight = Math.min(MAX_ROW_HEIGHT, Math.floor(gridHeight / Math.max(rowsPerCol, 1)));

  const rows = [];
  let qNum = 1;
  for (let col = 0; col < numCols; col++) {
    const colLeftX = col === 0 ? gridLeft : gridLeft + colWidth + COL_GAP;
    for (let r = 0; r < rowsPerCol && qNum <= numQuestions; r++, qNum++) {
      const rowY = gridTop + r * rowHeight;
      const bubbleY = rowY + (rowHeight - BUBBLE) / 2;
      const firstBubbleX = colLeftX + NUMBER_LABEL_W + ROW_PAD;
      const bubbles = ["A", "B", "C", "D"].map((value, i) => ({
        value,
        leftPct: pct(firstBubbleX + i * BUBBLES_GAP, PAGE_W),
        topPct: pct(bubbleY, PAGE_H),
      }));
      rows.push({
        questionNumber: qNum,
        col,
        numberLeftPct: pct(colLeftX, PAGE_W),
        numberTopPct: pct(rowY + rowHeight / 2 - 10, PAGE_H),
        bubbles,
      });
    }
  }

  return {
    numCols,
    rowsPerCol,
    rowHeight,
    // Container in phải giữ đúng tỉ lệ PAGE_W:PAGE_H (CSS aspect-ratio) để 2
    // giá trị % này quy ra cùng 1 kích thước vật lý (mm) -> bubble tròn đều,
    // không bị bầu dục. Dùng bubbleWidthPct cho CSS width (theo % chiều
    // rộng), bubbleHeightPct cho CSS height (theo % chiều cao).
    bubbleWidthPct: pct(BUBBLE, PAGE_W),
    bubbleHeightPct: pct(BUBBLE, PAGE_H),
    rows,
  };
}
